import $ from 'jquery'
import jQueryBridget from 'jquery-bridget'
import Isotope from 'isotope-layout'
jQueryBridget('isotope', Isotope, $)

export default function rangeSlider() {
  function setSuwakSlider() {
    var items = $('.rangeSlider a').length
    var parentWidth = $('.rangeSliderWrap ').width()
    var width = parentWidth / items
    $('.rangeSlider a:first-child').addClass('dropped')
    $('.rangeSlider a').each(function() {
      $(this).width(width)
      $(this).css('left', width * $(this).index())
    })
    var itemsWidth = $('.rangeSliderContainer .rangeSliderItem').width()
    var itemsLength = $('.rangeSliderContainer .rangeSliderItem').length
    $('.rangeSliderContainer').width(itemsWidth * itemsLength)
  }

  function setSuwak(selektor) {
    var position = $(selektor).css('left')
    $(selektor)
      .siblings()
      .removeClass('dropped')
    $(selektor).addClass('dropped')
    $('.suwak')
      .stop()
      .animate(
        {
          left: position
        },
        1000
      ) // do suwaka w portiolio ( masnory filter)

    if ($(selektor).data('filter') != undefined) {
      var filterName = $(selektor).data('filter')
      $('.portfolioGrid').isotope({
        filter: filterName
      })
    }

    setContainerPosition()
  }

  function setContainerPosition() {
    if ($('.rangeSlider a.dropped').length == 0) {
      var index = 0
      $('.rangeSlider a:first-child').addClass('dropped')
    } else {
      var index = $('.rangeSlider a.dropped').index()
    } //var left = $('.rangeSliderContainer').find('.rangeSliderItem:nth-child('+index+1+')').css('left');

    var width = $('.rangeSliderContainer')
      .find('.rangeSliderItem')
      .outerWidth()
    $('.rangeSliderContainer').css('left', '-' + width * index + 'px')
  }

  if ($('.suwak').length > 0) {
    $('.suwak').draggable({
      axis: 'x',
      containment: 'parent',
      //cursor: "crosshair",
      drag: function drag(event, ui) {
        $('.suwak').stop()
        $('.suwak').addClass('dragged')
      },
      stop: function stop(event, ui) {
        $('.suwak').removeClass('dragged')
      }
    })
  }

  if ($('.rangeSlider a').length > 0) {
    $('.rangeSlider a').droppable({
      drop: function drop(event, ui) {
        $(this).addClass('dropped')
        setSuwak(this) // do suwaka w portfolio (masonry filter)

        if ($(this).data('filter') != undefined) {
          var filterName = $(this).data('filter')
          $('.portfolioGrid').isotope({
            filter: filterName
          })
        }
      },
      out: function out(event, ui) {
        $(this).removeClass('dropped')
      }
    })
  }

  $('.rangeSlider a').click(function(e) {
    e.preventDefault()
    setSuwak(this)
  })

  setSuwakSlider()
}
